import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import api from "../../Webservices/api";
import { apiKey, apiKeyHeader } from "../../../../configs/ApiKeys";
import axios from "axios";
import { BASE_URL } from "../../../../configs/WebServiceUrl";
import userStore from "../../../../zustand/userStore";

const API_URL = "http://localhost:3001/api";
export const fetchTeachers = createAsyncThunk(
  "teachers/fetchTeachers",
  async (_, thunkAPI) => {
    const state = thunkAPI.getState();

    const schoolId = state.masterData.school_id;
    const userId = state.authSlice?.user?.id;
    const isIndividualLogin = state.authSlice?.user.roles === 'teacher';

    const response = await api.get(
      `/teachers/${schoolId}`,
      {
        params: userId && isIndividualLogin ? { user_id: userId } : {},
        headers: apiKeyHeader(),
      }
    );

    return response.data;
  }
);

export const fetchUnAssignTeachers = createAsyncThunk(
  "teachers/fetchUnAssignTeachers",
  async (_, thunkAPI) => {
    const state = thunkAPI.getState();
    const schoolId = state.masterData.school_id;
    const response = await axios.get(
      `${BASE_URL}/topic/un_assign_teacher/${schoolId}`,
      {
        headers: apiKeyHeader(),
      }
    );
    return response.data.teachers;
  }
);

export const UnAssignTeachers = createAsyncThunk(
  "teachers/UnAssignTeachers",
  async (_, thunkAPI) => {
    const state = thunkAPI.getState();
    const schoolId = state.masterData.school_id;
    const response = await axios.get(`${BASE_URL}/topic/users/unassigned`, {
      headers: apiKeyHeader(),
    });
    return response.data.data;
  }
);

export const createTeacher = createAsyncThunk(
  "teachers/createTeacher",
  async (teacherData) => {
    const response = await api.post(`/teachers`, teacherData, {
      headers: apiKeyHeader(),
    });
    fetchTeachers();
    return response.data;
  }
);

export const updateTeacher = createAsyncThunk(
  "teachers/updateTeacher",
  async ({ id, data }) => {
    const response = await api.put(`/teachers/${id}`, data, {
      headers: apiKeyHeader(),
    });
    return response.data;
  }
);

export const deleteTeacher = createAsyncThunk(
  "teachers/deleteTeacher",
  async ({ id, user_id }) => {
    await api.delete(`/teachers/${user_id}/${id}`, {
      headers: apiKeyHeader(),
    });
    return id;
  }
);

export const assignUser = createAsyncThunk(
  "user/assignUser",
  async (userData, thunkAPI) => {
    try {
      const response = await axios.post(
        `${BASE_URL}/api/auth/teacher-user-assignee`,
        userData,
        { headers: apiKeyHeader() }
      );

      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(
        error.response?.data?.message || error.message
      );
    }
  }
);

export const fetchTeacherDetails = createAsyncThunk(
  "teacherPlanner/fetchTeacherDetails",
  async (_, { rejectWithValue }) => {
    try {
      const userId = userStore.getState()?.user?.id;
      const res = await axios.get(
        `${BASE_URL}/topic/teacherby-user/${userId}`,
        { headers: apiKeyHeader() }
      );
      return res.data.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || "Something went wrong");
    }
  }
);

const teacherSlice = createSlice({
  name: "teachers",
  initialState: {
    teachers: [],
    loading: false,
    error: null,
    assignUser: false,
    teacherData: null,
    allteachers: [],
    allUsers: [],
    teacherDetails: {},
  },
  reducers: {
    setAssignUser: (state, action) => {
      state.assignUser = true;
      state.teacherData = action.payload;
      console.log("teacherData", state.teacherData);
    },
    clearAssignUser: (state) => {
      state.assignUser = false;
      state.teacherData = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchTeachers.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchTeachers.fulfilled, (state, action) => {
        state.loading = false;
        state.teachers = action.payload;
      })
      .addCase(fetchTeachers.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })
      .addCase(createTeacher.fulfilled, (state, action) => {
        state.loading = false;
      })
      .addCase(updateTeacher.fulfilled, (state, action) => {
        const index = state.teachers.findIndex(
          (teacher) => teacher.teacher_id === action.payload.teacher_id
        );
        if (index !== -1) {
          state.teachers[index] = action.payload;
        }
      })
      .addCase(deleteTeacher.fulfilled, (state, action) => {
        state.teachers = state.teachers.filter(
          (teacher) => teacher.teacher_id !== action.payload
        );
      })
      .addCase(assignUser.pending, (state) => {
        state.loading = true;
      })
      .addCase(assignUser.fulfilled, (state, action) => {
        state.loading = false;
      })
      .addCase(assignUser.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })
      .addCase(fetchUnAssignTeachers.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchUnAssignTeachers.fulfilled, (state, action) => {
        state.loading = false;
        state.allteachers = action.payload;
      })
      .addCase(fetchUnAssignTeachers.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })
      .addCase(UnAssignTeachers.pending, (state) => {
        state.loading = true;
      })
      .addCase(UnAssignTeachers.fulfilled, (state, action) => {
        state.loading = false;
        state.allUsers = action.payload;
      })
      .addCase(UnAssignTeachers.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })
      .addCase(fetchTeacherDetails.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchTeacherDetails.fulfilled, (state, action) => {
        state.loading = false;
        state.teacherDetails = action.payload;
        try {
          const storedUser = JSON.parse(localStorage.getItem("userData")) || {};
          const updatedUser = {
            ...storedUser,
            teacher_id: action.payload.teacher_id,
          };
          localStorage.setItem("userData", JSON.stringify(updatedUser));
          const { setUser } = userStore.getState();
          setUser(updatedUser);
        } catch (error) {
          console.error("Error updating teacher_id in userData:", error);
        }
      })
      .addCase(fetchTeacherDetails.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      });
  },
});

export const { setAssignUser, clearAssignUser } = teacherSlice.actions;
export default teacherSlice.reducer;
